import type { Theme } from '@mui/material/styles';
import { accentHues } from './tokens';

/**
 * Readable text colour for a tinted accent, mirroring the prototype's `ink()` map: the raw hue is
 * fine on a dark surface but too light on white, so each accent has its own ink token.
 */
export function inkFor(theme: Theme, hue: string): string {
  const inks: Record<string, string> = {
    [accentHues.green]: theme.vars.palette.md.primaryStrong,
    [accentHues.blue]: theme.vars.palette.md.blueInk,
    [accentHues.violet]: theme.vars.palette.md.violetInk,
    [accentHues.amber]: theme.vars.palette.md.warnInk,
    [accentHues.rose]: theme.vars.palette.md.badInk,
    [accentHues.emerald]: theme.vars.palette.md.okInk,
    [accentHues.slate]: theme.vars.palette.md.muted,
  };
  return inks[hue] ?? hue;
}
